// extracted by mini-css-extract-plugin
export default {"cls1":"ResearcherList-cls1__e3d8f08a29188364324c","cls2":"ResearcherList-cls2___b1d60acdf847c751cb6 ResearcherList-cls1__e3d8f08a29188364324c"};